import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CTAButton } from '../ui/CTAButton';
export function Offer() {
  return <section className="bg-white py-24 md:py-32 px-6" data-id="element-141">
      <div className="max-w-3xl mx-auto" data-id="element-142">
        <div className="bg-navy-900 rounded-[2.5rem] p-8 md:p-16 shadow-2xl relative overflow-hidden" data-id="element-143">
          {/* Decorative glow */}
          <div className="absolute top-0 right-0 w-96 h-96 bg-gold-500/10 blur-3xl rounded-full transform translate-x-1/2 -translate-y-1/2" data-id="element-144"></div>

          <div className="relative z-10 text-center" data-id="element-145">
            <FadeIn delay={0.1} data-id="element-146">
              <h2 className="font-serif text-3xl md:text-4xl text-cream-50 font-bold mb-6" data-id="element-147">
                Proteja su legado y su autonomía
              </h2>
              <p className="text-xl text-cream-100/90 mb-8 leading-relaxed" data-id="element-148">
                Hoy puede obtener el sistema completo de "Memoria Blindada" por
                una fracción de lo que costaría una sola consulta privada.
              </p>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-149">
              <div id="oferta" className="mb-10 scroll-mt-24" data-id="element-150">
                <span className="block text-cream-100/60 text-base md:text-lg line-through mb-1" data-id="element-151">
                  Valor de consulta privada: $150+
                </span>
                <span className="block text-cream-100/70 text-lg md:text-xl line-through mb-3" data-id="element-152">
                  Precio regular: $27
                </span>

                <div className="inline-block bg-red-500/90 text-white text-xs md:text-sm font-bold uppercase tracking-wider px-3 py-1 rounded-full mb-4" data-id="element-153">
                  Oferta especial · 76% de descuento
                </div>

                <div className="flex items-baseline justify-center gap-2" data-id="element-154">
                  <span className="text-xl md:text-2xl text-gold-400 font-medium" data-id="element-155">
                    Hoy solo
                  </span>
                  <span className="font-serif text-6xl md:text-7xl font-bold text-gold-400" data-id="element-156">
                    $6.39
                  </span>
                </div>
                <p className="text-cream-100/60 text-sm mt-2" data-id="element-157">
                  Pago único · Acceso de por vida
                </p>
              </div>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-158">
              <CTAButton showTrustBadges={true} label="DESCARGAR MEMORIA BLINDADA AHORA" href="https://soscalma.com/cart/53275249377593:1" data-id="element-159" />
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}